import { ORDER_METHODS, RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'En el local',
      [RoomServiceLocationType.TableService]: 'En el local',
      both: 'En el local',
    },
    [ORDER_METHODS.PICKUP]: 'Recogida',
    [ORDER_METHODS.DELIVERY]: 'Entrega a domicilio',
  },
};
